/**
 * i18n Configuration
 *
 * Internationalization setup using i18next
 * Supports Czech (cs) and English (en)
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import cs from './locales/cs.json'
import en from './locales/en.json'

const resources = {
	cs: { translation: cs },
	en: { translation: en },
}

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'cs',
		supportedLngs: ['cs', 'en'],

		interpolation: {
			escapeValue: false, // React already escapes values
		},

		detection: {
			order: ['localStorage', 'navigator', 'htmlTag'],
			caches: ['localStorage'],
			lookupLocalStorage: 'polygraf-language',
		},

		react: {
			useSuspense: false,
		},
	})

// Keep <html lang> in sync with the active i18n language so screen readers
// pronounce content in the right language. The HTML template hardcodes
// lang="cs"; without this listener it stays "cs" forever even after the
// user switches to English (WCAG 3.1.1 / 3.1.2 violation).
function syncHtmlLang(lng: string) {
	if (typeof document !== 'undefined') {
		document.documentElement.lang = lng
	}
}
syncHtmlLang(i18n.language)
i18n.on('languageChanged', syncHtmlLang)

export default i18n

// Export for convenience
export const changeLanguage = (lng: string) => i18n.changeLanguage(lng)
export const getCurrentLanguage = () => i18n.language
export const supportedLanguages = [
	{ code: 'cs', name: 'Čeština', flag: '🇨🇿' },
	{ code: 'en', name: 'English', flag: '🇬🇧' },
]
